import React, { FC } from 'react';
import { Button } from 'antd';
import { FindingTypeProperty } from '../AnnotationStandardForm.slice';

type Props = {
  findingTypeId: string;
  properties: Array<FindingTypeProperty>;
  canEdit: boolean;
  onAddNewRow: (findingTypeId: string) => void;
};

const NewRuleRow: FC<Props> = ({ properties, canEdit, findingTypeId, onAddNewRow }) => {
  return (
    <div style={{ margin: '0 auto', width: '29%', marginTop: '10px' }}>
      {properties.map((x, index) =>
        index === properties.length - 1 ? (
          <div key={index}>
            <Button disabled={!canEdit} type='default' style={{ width: '100%' }} onClick={() => onAddNewRow(findingTypeId)}>
              Add rule
            </Button>
          </div>
        ) : (
          <div key={index}></div>
        )
      )}
    </div>
  );
};

export default NewRuleRow;
